import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch } from 'react-redux';
import { setShowContextMenu } from 'store/ManageGeneral/actions';
import { openModal } from 'store/modals/actions';
import { MODAL_APPLY_TEMPLATE } from 'store/modals/modals';
import { TemplateIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';

const ApplyTemplate = () => {
  const dispatch = useDispatch();

  return (
    <MenuItem
      title="Apply Template"
      icon={ <TemplateIcon /> }
      onClick={ () => {
        dispatch(openModal(MODAL_APPLY_TEMPLATE));
        dispatch(setShowContextMenu(false));
      } }
    />
  );
};

export default ApplyTemplate;
